import { ArrowRight, ChevronDown } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function Hero({ onUploadClick, onPackagesClick }) {
  const navigate = useNavigate();
  
  const handleSubmitTender = () => {
    navigate("/tender-red-review#tender-form");
  };

  const handleSeeChecks = () => {
    navigate("/tender-red-review#what-we-check");
  };

  return (
    <section
      id="hero"
      className="relative w-full"
      data-testid="hero-section"
    >
      {/* Container with construction imagery */}
      <div 
        className="relative min-h-screen w-full bg-cover bg-no-repeat"
        style={{ 
          backgroundImage: "url('https://images.unsplash.com/photo-1503387837-b154d5074bd2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHw0fHxjb25zdHJ1Y3Rpb24lMjBibHVlcHJpbnRzJTIwZXN0aW1hdGluZyUyMHRlbmRlciUyMGRvY3VtZW50cyUyMHBsYW5zfGVufDB8fHx8MTc4OTY5MzA5N3ww&ixlib=rb-4.1.0&q=85')",
          backgroundPosition: 'center center',
          backgroundSize: 'cover'
        }}
      >
        {/* Overlay gradient */}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/40 pointer-events-none" />
        
        {/* Content - centered */}
        <div className="relative min-h-screen flex items-center">
          <div className="max-w-7xl mx-auto px-6 md:px-12 w-full">
            <div className="max-w-3xl">
              <div className="space-y-5 md:space-y-6">
                {/* Eyebrow */}
                <span className="font-mono text-sm uppercase tracking-widest text-zinc-400">
                  Construction Cost Engineering & Tender Assurance
                </span>
                
                <div className="space-y-4 md:space-y-5">
                  <h1
                    className="font-heading font-bold text-3xl sm:text-4xl md:text-5xl lg:text-6xl uppercase tracking-tight leading-[1.1] text-white drop-shadow-lg"
                    data-testid="hero-headline"
                  >
                    Catch the mistake before it becomes the job.
                  </h1>
                  <p
                    className="font-body text-base sm:text-lg md:text-xl text-zinc-200 max-w-2xl leading-relaxed drop-shadow-md"
                    data-testid="hero-subheadline"
                  >
                    You've measured it. You've priced it. Before you submit it, Blackline gives your tender one independent commercial preflight - scope gaps, duplicate allowances, quote exclusions, estimate integrity, build-up assumptions, programme logic and commercial exposure.
                  </p>
                </div>

                {/* CTAs */}
                <div
                  className="flex flex-col sm:flex-row gap-3 sm:gap-4"
                  data-testid="hero-ctas"
                >
                  <button
                    onClick={handleSubmitTender}
                    className="bg-white text-black h-12 sm:h-14 px-6 sm:px-8 uppercase font-bold text-sm tracking-widest border-2 border-white btn-brutal flex items-center justify-center gap-3 group hover:bg-zinc-100"
                    data-testid="hero-cta-primary"
                  >
                    Submit a Tender for Review
                    <ArrowRight
                      size={20}
                      className="group-hover:translate-x-1 transition-transform"
                    />
                  </button>
                  <button
                    onClick={handleSeeChecks}
                    className="bg-transparent text-white h-12 sm:h-14 px-6 sm:px-8 uppercase font-bold text-sm tracking-widest border-2 border-white hover:bg-white/10 transition-colors flex items-center justify-center"
                    data-testid="hero-cta-secondary"
                  >
                    See What We Check
                  </button>
                </div>

                {/* Microcopy */}
                <p className="font-mono text-xs sm:text-sm text-zinc-400 max-w-xl">
                  Standard founding review: target 24 hours · NZ$595 / A$545 excl. GST · one substantially complete tender or estimate
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <button 
          onClick={() => {
            const nextSection = document.getElementById('founding-offer');
            if (nextSection) {
              nextSection.scrollIntoView({ behavior: 'smooth' });
            }
          }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce cursor-pointer hover:scale-110 transition-transform"
          aria-label="Scroll to next section"
        >
          <ChevronDown size={32} className="text-white/80 drop-shadow-lg" />
        </button>
      </div>
    </section>
  );
}
